import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    createPerson(rootState, themeId, newPerson, picture, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La création du personnage «' + newPerson.name + '» a échoué.',
                type: 'danger'
            });
        };

        let formData = new FormData();

        formData.append("data", JSON.stringify({
            "name": newPerson.name,
            "gender": newPerson.gender,
            "description": newPerson.description ? newPerson.description : ""
        }));

        if (picture)   {
            formData.append("picture", picture);
        }

        Vue.axios.post(rootState.baseUrl + "/admin/theme/" + themeId + "/person/create", formData, {"headers": rootState.postDataHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    updatePerson(rootState, themeId, newPerson, picture, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La mise à jour du personnage «' + newPerson.name + '» a échoué.',
                type: 'danger'
            });
        };

        let formData = new FormData();

        formData.append("data", JSON.stringify({
            "name": newPerson.name,
            "gender": newPerson.gender,
            "description": newPerson.description ? newPerson.description : ""
        }));

        if (picture)   {
            formData.append("picture", picture);
        }

        Vue.axios.post(rootState.baseUrl + "/admin/theme/" + themeId + "/person/update/" + newPerson.id, formData, {"headers": rootState.postDataHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    deletePerson(rootState, personToDelete, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La suppression du personnage «' + personToDelete.name + '» a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.delete(rootState.baseUrl + "/admin/person/delete/" + personToDelete.id, {"headers": rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success();
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getPersonList(rootState, themeId, page, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération de la liste des personnages a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/theme/" + themeId + "/persons/" + page, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getPerson(rootState, personId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération du personnage a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/common/person/" + personId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.person);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getPersonDetail(rootState, personId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération du personnage a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/common/person/" + personId + '/detail', {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.person);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });  
    },
    linkUserToPerson(rootState, personId, newUser, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La liaison de l'utilisateur avec le personnage a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "id": newUser.id ? newUser.id : null,
            "email": newUser.email
        })});
        Vue.axios.post(rootState.baseUrl + "/admin/person/" + personId + "/link-user", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    generateVoicesForPerson(rootState, personId, textToSpeechData, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La génération des fichiers sons a échoué.',
                type: 'danger'
            });
        };

        let formData = new FormData();
        formData.append("data", JSON.stringify(textToSpeechData));

        Vue.axios.post(rootState.baseUrl + "/admin/person/" + personId + "/generate-voices", formData, {"headers": rootState.postDataHeaders}).then((response) => {
            if (callbacks.success)  {
                callbacks.success(response.data.id);
            }
            return true;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};